export const t = v => String(v ?? "").trim() || "-";
export const businessName = b => t(b?.businessName || b?.legalName || b?.name);
export const itemName = i => t(i?.itemName || i?.name || i?.description);
export const customerMobile = (c, i) => t(c?.mobile || i?.customer?.mobile);
export const total = (totals, key) => Number(totals?.[key] || 0);
